import React, { useRef } from 'react';
var VeltCommentsSidebarV2FocusedThreadDialogContainer = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-focused-thread-dialog-container-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2FocusedThreadDialogContainer;
